import * as Types from '../../generated-types';

import { GraphQLClient } from 'graphql-request';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
export type CreatePendingPunchMutationVariables = Types.Exact<{
  dayId: Types.Scalars['ID'];
  punchId: Types.Scalars['ID'];
  in?: Types.InputMaybe<Types.Scalars['Time']>;
  out?: Types.InputMaybe<Types.Scalars['Time']>;
  oldIn?: Types.InputMaybe<Types.Scalars['Time']>;
  oldOut?: Types.InputMaybe<Types.Scalars['Time']>;
  penalty?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type CreatePendingPunchMutation = { __typename?: 'Mutation', createPendingPunch?: { __typename?: 'PendingPunch', documentId: string, in?: any | null, out?: any | null, oldIn?: any | null, oldOut?: any | null, approved?: boolean | null, penalty?: number | null, punch?: { __typename?: 'Punch', documentId: string } | null } | null };

export type UpdatePendingPunchMutationVariables = Types.Exact<{
  punchId: Types.Scalars['ID'];
  userId: Types.Scalars['ID'];
  approved?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type UpdatePendingPunchMutation = { __typename?: 'Mutation', updatePendingPunch?: { __typename?: 'PendingPunch', documentId: string, in?: any | null, out?: any | null, approved?: boolean | null, penalty?: number | null, punch?: { __typename?: 'Punch', documentId: string, in?: any | null, out?: any | null, location: string } | null } | null };

export type UpdatePendingPunchTimeMutationVariables = Types.Exact<{
  punchId: Types.Scalars['ID'];
  in?: Types.InputMaybe<Types.Scalars['Time']>;
  out?: Types.InputMaybe<Types.Scalars['Time']>;
  penalty?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type UpdatePendingPunchTimeMutation = { __typename?: 'Mutation', updatePendingPunch?: { __typename?: 'PendingPunch', documentId: string, in?: any | null, out?: any | null, approved?: boolean | null, penalty?: number | null, punch?: { __typename?: 'Punch', documentId: string } | null } | null };

export type DeletePendingPunchMutationVariables = Types.Exact<{
  punchId: Types.Scalars['ID'];
}>;


export type DeletePendingPunchMutation = { __typename?: 'Mutation', deletePendingPunch?: { __typename?: 'DeleteMutationResponse', documentId: string } | null };


export const CreatePendingPunchDocument = `
    mutation CreatePendingPunch($dayId: ID!, $punchId: ID!, $in: Time, $out: Time, $oldIn: Time, $oldOut: Time, $penalty: Int) {
  createPendingPunch(
    data: {day: $dayId, punch: $punchId, in: $in, out: $out, oldIn: $oldIn, oldOut: $oldOut, penalty: $penalty}
  ) {
    documentId
    in
    out
    oldIn
    oldOut
    approved
    punch {
      documentId
    }
    penalty
  }
}
    `;
export const useCreatePendingPunchMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreatePendingPunchMutation, TError, CreatePendingPunchMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreatePendingPunchMutation, TError, CreatePendingPunchMutationVariables, TContext>(
      ['CreatePendingPunch'],
      (variables?: CreatePendingPunchMutationVariables) => fetcher<CreatePendingPunchMutation, CreatePendingPunchMutationVariables>(client, CreatePendingPunchDocument, variables, headers)(),
      options
    );
export const UpdatePendingPunchDocument = `
    mutation UpdatePendingPunch($punchId: ID!, $userId: ID!, $approved: Boolean) {
  updatePendingPunch(
    documentId: $punchId
    data: {approved: $approved, approvedBy: $userId}
  ) {
    documentId
    in
    out
    approved
    punch {
      documentId
      in
      out
      location
    }
    penalty
  }
}
    `;
export const useUpdatePendingPunchMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePendingPunchMutation, TError, UpdatePendingPunchMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdatePendingPunchMutation, TError, UpdatePendingPunchMutationVariables, TContext>(
      ['UpdatePendingPunch'],
      (variables?: UpdatePendingPunchMutationVariables) => fetcher<UpdatePendingPunchMutation, UpdatePendingPunchMutationVariables>(client, UpdatePendingPunchDocument, variables, headers)(),
      options
    );
export const UpdatePendingPunchTimeDocument = `
    mutation UpdatePendingPunchTime($punchId: ID!, $in: Time, $out: Time, $penalty: Int) {
  updatePendingPunch(
    documentId: $punchId
    data: {in: $in, out: $out, penalty: $penalty}
  ) {
    documentId
    in
    out
    approved
    punch {
      documentId
    }
    penalty
  }
}
    `;
export const useUpdatePendingPunchTimeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePendingPunchTimeMutation, TError, UpdatePendingPunchTimeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdatePendingPunchTimeMutation, TError, UpdatePendingPunchTimeMutationVariables, TContext>(
      ['UpdatePendingPunchTime'],
      (variables?: UpdatePendingPunchTimeMutationVariables) => fetcher<UpdatePendingPunchTimeMutation, UpdatePendingPunchTimeMutationVariables>(client, UpdatePendingPunchTimeDocument, variables, headers)(),
      options
    );
export const DeletePendingPunchDocument = `
    mutation DeletePendingPunch($punchId: ID!) {
  deletePendingPunch(documentId: $punchId) {
    documentId
  }
}
    `;
export const useDeletePendingPunchMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeletePendingPunchMutation, TError, DeletePendingPunchMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeletePendingPunchMutation, TError, DeletePendingPunchMutationVariables, TContext>(
      ['DeletePendingPunch'],
      (variables?: DeletePendingPunchMutationVariables) => fetcher<DeletePendingPunchMutation, DeletePendingPunchMutationVariables>(client, DeletePendingPunchDocument, variables, headers)(),
      options
    );